import * as types from '../mutation-types'

const state = {
  nextEvent: null,
  eventLock: false,
  eventQuee: []
}

const mutations = {
  [types.ADD_EVENT] (state, action) {
    if (!state.eventLock) {
      state.eventLock = true
      state.nextEvent = action
    } else {
      state.eventQuee.push(action)
    }
  },

  [types.UNLOCK_EVENT] (state) {
    if (state.eventQuee.length) {
      state.nextEvent = state.eventQuee.shift()
    } else {
      state.nextEvent = null
      state.eventLock = false
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/event.js